import {
  buildExternalCalendarFeedBreadcrumb,
  fromZonedTime,
  toZonedEventTimes,
} from '@griply/utils';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';
import { Timestamp } from 'shared/types/timestamp';

import { getFunctions } from './helpers';
import { externalCalendarSanitizer } from './helpers/external-calendar-sanitizer';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
  timezone: string;
};

export const getExternalCalendarEvents = async ({
  startDate,
  endDate,
  timezone,
}: Options) => {
  const functions = getFunctions();
  // Provider-authored data: only the sanitizer turns it into ExternalCalendarEvent.
  const fetchEvents = httpsCallable<
    { startDate: string; endDate: string; timezone: string },
    unknown
  >(functions, 'externalCalendars-getEvents');

  // The window arrives as the wall clock the grid shows — `timezone`'s — not as real instants.
  const { data } = await fetchEvents({
    startDate: fromZonedTime(startDate, timezone).toISOString(),
    endDate: fromZonedTime(endDate, timezone).toISOString(),
    timezone,
  });

  const events = externalCalendarSanitizer.sanitizeEvents(data);
  getErrorReporter().addBreadcrumb(
    buildExternalCalendarFeedBreadcrumb(
      events.length,
      Array.isArray(data) ? data.length : 0,
    ),
  );

  return events.map((event) => toZonedEventTimes(event, timezone));
};
